import { render } from "./CustomSelectContainer.vue?vue&type=template&id=63303514&scoped=true"
import script from "./CustomSelectContainer.vue?vue&type=script&lang=js"
export * from "./CustomSelectContainer.vue?vue&type=script&lang=js"

import "./CustomSelectContainer.vue?vue&type=style&index=0&id=63303514&scoped=true&lang=css"

import exportComponent from "/usr/share/node/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63303514"]])

export default __exports__